import React from 'react'
import { ScoreInput } from '../../lib'

const OneToTenInput = ({ onChange, ...rest }) => {
  return (
    <ScoreInput
      {...rest}
      onChange={n => onChange(n, true)}
      className='OneToTenInput'
    />
  )
}

OneToTenInput.displayName = 'OneToTenInput'

export default OneToTenInput



// WEBPACK FOOTER //
// ./src/assess/question/OneToTenInput.js